module.exports = __webpack_public_path__ + "images/dir@2x-4a7a9304f019354d7a53889ab009cecd.png";